import { useWadGTM } from '~/composables/useWadGTM'

export function useDeveloperSignup() {
  const config = useRuntimeConfig()
  const wadPlatformBaseUrl = config.public.wadPlatformBaseUrl
  const router = useRouter()
  const localePath = useLocalePath()
  const { pushGTMValues } = useWadGTM()

  const videoDetailsPageUrl = (video: any) => {
    return video ? localePath({name: 'videos-id-slug', params: { id: video.id, slug: video.slug }}) : null
  }

  const protectedVideoLoginRedirectUrl = (video: any) => {
    // Relative /user/* path: resolves on both www and companies hosts
    return `/user/login?redirect=${videoDetailsPageUrl(video)}`;
  }

  const protectedVideoSignupRedirectUrl = (video: any) => {
    return `/developer/sign-up?redirect=${videoDetailsPageUrl(video)}`;
    //TODO: Update when login page is migrated
    //return `${localePath({ name: 'user-signup' })}?redirect=${videoDetailsPageUrl(video)}`
  }

  const getDeveloperSignupUrl = () => {
    return `/developer/sign-up`;
  }

  const navigateToSignupForSignupAsDeveloper = (isVideo: boolean) => {
    if (!isVideo) {
      pushGTMValues('developer-registration_registration-started-direct')
    } else {
      pushGTMValues('developer-registration_registration-started-video-details')
    }
    navigateTo(getDeveloperSignupUrl(), {external: true});
  }

  return {
    videoDetailsPageUrl,
    protectedVideoLoginRedirectUrl,
    protectedVideoSignupRedirectUrl,
    navigateToSignupForSignupAsDeveloper,
  }
}
